import { createAction } from '@reduxjs/toolkit';

export const show = createAction('themeBlack/show');
export const hide = createAction('themeBlack/hide');
